import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import {
  AppBar, // アプリケーションバー
  Box, // 基本的なレイアウトコンポーネント
  Button, // ボタン
  Card, // カード（今回は未使用）
  CardContent, // カードコンテンツ（今回は未使用）
  Container, // コンテナ（今回は未使用）
  Divider, // 区切り線
  Drawer, // ドロワー（今回は未使用）
  FormControl, // フォームコントロール（Selectなどのラッパー）
  FormControlLabel, // ラベル付きフォームコントロール（Switch用）
  Grid, // グリッドレイアウト
  IconButton, // アイコンボタン
  InputLabel, // 入力ラベル（Select用）
  LinearProgress, // 線形プログレスバー
  List, // リスト
  ListItem, // リストアイテム
  ListItemText, // リストアイテムテキスト
  MenuItem, // Select内のメニューアイテム
  Paper, // ペーパー（背景や枠線を提供）
  Select, // セレクトボックス
  Slider, // スライダー（未使用機能）
  Stack, // Stackレイアウト（要素を縦・横に並べる）
  Switch, // スイッチ（オン/オフ）
  Tab, // タブ
  Tabs, // タブグループ
  TextField, // テキストフィールド（プロンプト入力用）
  Toolbar, // ツールバー（AppBar内）
  Typography, // テキスト表示
  useTheme, // テーマ（色など）を取得するフック
  useMediaQuery, // メディアクエリフック
  CircularProgress, // 円形プログレスインジケータ
  Snackbar, // スナックバー（通知用）
  Alert, // アラート（Snackbar内）
  Chip, // チップ（ステータス表示用）
  Link, // リンク
  Dialog, // ダイアログ（モーダル）
  DialogActions, // ダイアログのアクションエリア
  DialogContent, // ダイアログのコンテンツエリア
  DialogContentText, // ダイアログ内のテキスト
  DialogTitle, // ダイアログのタイトル
  Tooltip // ツールチップ（情報表示用）
} from '@mui/material';

// MUIアイコンのインポート
import {
  Upload as UploadIcon, // アップロード
  Videocam as VideocamIcon, // 動画
  AutoFixHigh as WandIcon, // 魔法の杖（生成）
  Layers as LayersIcon, // レイヤー（未使用）
  AccessTime as ClockIcon, // 時計（待機中）
  GetApp as DownloadIcon, // ダウンロード（未使用）
  Share as ShareIcon, // 共有（未使用）
  Settings as SettingsIcon, // 設定
  ExpandMore as ExpandMoreIcon, // 詳細展開
  Add as AddIcon, // 追加（未使用）
  DeleteOutline as DeleteIcon, // 削除（未使用）
  PlayArrow as PlayArrowIcon, // 再生（プレビュー用）
  MonetizationOn as PriceIcon, // 料金
  History as HistoryIcon, // 履歴
  Cancel as CancelIcon, // キャンセル
  Info as InfoIcon, // 情報・詳細
  Public as PublicIcon, // 公開
  Lock as PrivateIcon, // 非公開
  Refresh as RefreshIcon, // 更新
  Movie as MovieIcon, // 動画・モデル
  AspectRatio as AspectRatioIcon, // 縦横比
  CreditCard as CreditCardIcon, // Stripe用
  AccountBalanceWallet as WalletIcon, // 他の決済方法用（例）
  Close as CloseIcon // モーダル閉じる用
} from '@mui/icons-material';
import ApiFetch from '../ApiFetch'; // APIベースURLなどを定義したファイル(想定)
import PaymentMethodSelector from './PaymentMethodSelector'; // ポイント/コイン決済セレクター
import { LoginInfo } from '../../App'; // ログイン情報コンテキスト

// --- Stripe設定 ---
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router';
// ★★★ Stripe パブリッシュ可能キー (環境変数から取得推奨) ★★★
// 環境変数 REACT_APP_STRIPE_PUBLISHABLE_KEY がなければ、'pk_test_...' の部分を使う
// 重要：'pk_test_...' は実際のテストキーに置き換えてください
// process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 
// const STRIPE_PUBLISHABLE_KEY = 'pk_test_51N6KSwCzuTH4dJGfT64wxH2grX63myBebzBB8xIKgCpa6AFqH4aUVDAlJV8GZWGbTMM5MuXBiWqUUcnrZ9Ryfsng00cs38GaYi';
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51N6KSwCzuTH4dJGfEFmas6KpjRFTsKotDVwQEmh4btLmuSQRPnsTLfcLfSiKSPMYfWjeCnMYgsA7leXL2Uq8Y9ig00Ibq8UYT0';
// Stripe.jsを非同期でロード
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// --- APIクライアント設定 ---
// ApiFetchコンポーネントからAPIのベースURLを取得
const API_BASE_URL = ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + '/v1';
// APIリクエストを行うヘルパーオブジェクト
const apiClient = {
  // GETリクエスト (Cookieなどの認証情報を含む)
  get: async (endpoint) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, { credentials: 'include' });
    if (!response.ok) { // エラーチェック
      const errorData = await response.json().catch(() => ({ errors: ['Network error'] }));
      throw new Error(errorData.errors?.join(', ') || `HTTP error! status: ${response.status}`);
    }
    return response.json(); // 成功時はJSONをパースして返す
  },
  // POSTリクエスト (Cookieなどの認証情報を含む)
  post: async (endpoint, body) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }, // JSON形式で送信
      body: JSON.stringify(body), // リクエストボディをJSON文字列化
      credentials: 'include', // Cookie等を含む
    });
    if (!response.ok) { // エラーチェック
      const errorData = await response.json().catch(() => ({ errors: ['Network error'] }));
      throw new Error(errorData.errors?.join(', ') || `HTTP error! status: ${response.status}`);
    }
    return response.json(); // 成功時はJSONをパースして返す
  },
};
// --- APIクライアント設定終了 ---

// --- ヘルパーコンポーネント ---

// タブパネル: valueとindexが一致するタブの内容を表示
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && ( <Box sx={{ p: 3, pt: 2 }}>{children}</Box> )}
    </div>
  );
}

// ステータス表示用Chip: 数値をアイコン付きのChipに変換
const getStatusChip = (status) => {
    switch (status) {
        case 0: return <Chip label="待機中" color="warning" size="small" icon={<ClockIcon />} />;
        case 1: return <Chip label="処理中" color="info" size="small" icon={<CircularProgress size={16} color="inherit" />} />;
        case 2: return <Chip label="完了" color="success" size="small" icon={<VideocamIcon />} />;
        case 3: return <Chip label="エラー" color="error" size="small" icon={<CancelIcon />} />;
        default: return <Chip label="不明" size="small" />;
    }
};

// ファイルパス表示用リンク: DBのファイルパス情報からダウンロードリンクを生成
const formatFilePath = (filePathData, procId) => {
    // データがない、空配列、最初の要素やパスがない場合は「ファイルなし」
    if (!filePathData || !Array.isArray(filePathData) || filePathData.length === 0) { return <Typography variant="caption" color="text.secondary">ファイルなし</Typography>; }
    const firstVideo = filePathData[0]; if (!firstVideo || !firstVideo.path) { return <Typography variant="caption" color="text.secondary">パス情報なし</Typography>; }
    // サーバー側の動画提供パスに合わせてURLを構築 (例: /videos/...)
    const videoUrl = `/videos/${firstVideo.path}`;
    const fileName = firstVideo.path.split('/').pop(); // パスからファイル名抽出
    // リンクコンポーネントを返す
    return ( <Link href={videoUrl} target="_blank" rel="noopener noreferrer" variant="caption"> {fileName || '動画ファイル'} {firstVideo.mimeType ? `(${firstVideo.mimeType})` : ''} </Link> );
};
// --- ヘルパーコンポーネント終了 ---

// --- メインコンポーネント: AIVideoGenerator ---
const AIVideoGenerator = () => {
  const theme = useTheme(); // Material UIのテーマを使用
  const navigate = useNavigate(); // React Routerのナビゲーションフック
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // モバイル判定
  const historyListRef = useRef(null); // 履歴リストのスクロール位置保存用ref
  // --- State定義 ---
  const [tabValue, setTabValue] = useState(0); // 現在選択中のタブ (0: Text to Video)
  const [isGenerating, setIsGenerating] = useState(false); // 決済処理中またはAPI通信中のフラグ
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false); // 詳細設定表示フラグ
  const [prompt, setPrompt] = useState(''); // プロンプト入力内容
  const [currentModel, setCurrentModel] = useState('sora-2'); // 現在選択中のモデル

  // --- モデル設定プリセット ---
  // 各モデルのデフォルト設定や選択肢を定義
  const MODEL_PRESETS = {
    veo2: {
      name: "Veo2", description: "高度な動画生成モデル",
      defaultSettings: { style: 'none', aspectRatio: '9:16', durationSeconds: 5, frameRate: 24, hasAudio: false, audioType: 'none', variationCount: 1, publicFlg: false, motionStrength: 7 },
      availableStyles: [{ value: 'none', label: '指定なし'}, { value: 'realistic', label: 'フォトリアル' }, { value: 'anime', label: 'アニメ風' }, { value: '3d', label: '3D' }, { value: 'watercolor', label: '水彩画' }, { value: 'cinematic', label: '映画風' }],
      availableAspectRatios: [{ value: '16:9', label: '横向き', width: 1280, height: 720 }, { value: '9:16', label: '縦向き', width: 720, height: 1280 }],
      availableVideoLengths: [{ value: 5, label: '5秒' }, { value: 6, label: '6秒' }, { value: 7, label: '7秒' }, { value: 8, label: '8秒' }],
      availableFrameRates: [{ value: 24, label: '24 fps' }],
      availableVariationCounts: [{ value: 1, label: '1枚' }, { value: 2, label: '2枚' }, { value: 3, label: '3枚' }, { value: 4, label: '4枚' }],
      availableAudioOptions: [{ value: 'none', label: 'なし' }] // 音声は現状「なし」のみ
    },
    'sora-2': {
      name: "Sora 2", description: "高品質動画生成モデル",
      defaultSettings: { style: 'none', aspectRatio: '9:16', durationSeconds: 8, frameRate: 30, hasAudio: true, audioType: 'auto', variationCount: 1, publicFlg: false, motionStrength: 7 },
      availableStyles: [{ value: 'none', label: '指定なし' }],
      availableAspectRatios: [{ value: '16:9', label: '横向き', width: 1280, height: 720 }, { value: '9:16', label: '縦向き', width: 720, height: 1280 }],
      availableVideoLengths: [{ value: 4, label: '4秒' }, { value: 8, label: '8秒' }, { value: 12, label: '12秒' }],
      availableFrameRates: [{ value: 30, label: '30 fps' }],
      availableVariationCounts: [{ value: 1, label: '1枚' }],
      availableAudioOptions: [{ value: 'auto', label: '音声追加（常時オン）' }],
      pricing: { 4: 250, 8: 360, 12: 450 } // 秒数別固定料金
    },
    'sora-2-pro': {
      name: "Sora 2 Pro", description: "プロフェッショナル動画生成モデル",
      defaultSettings: { style: 'none', aspectRatio: '9:16', durationSeconds: 8, frameRate: 30, hasAudio: true, audioType: 'auto', variationCount: 1, publicFlg: false, motionStrength: 7 },
      availableStyles: [{ value: 'none', label: '指定なし' }],
      availableAspectRatios: [{ value: '16:9', label: '横向き', width: 1280, height: 720 }, { value: '9:16', label: '縦向き', width: 720, height: 1280 }],
      availableVideoLengths: [{ value: 4, label: '4秒' }, { value: 8, label: '8秒' }, { value: 12, label: '12秒' }],
      availableFrameRates: [{ value: 30, label: '30 fps' }],
      availableVariationCounts: [{ value: 1, label: '1枚' }],
      availableAudioOptions: [{ value: 'auto', label: '音声追加（常時オン）' }],
      pricing: { 4: 540, 8: 960, 12: 1260 } // 秒数別固定料金
    },
  };
  // 現在選択されているモデルの設定を取得
  const currentPreset = MODEL_PRESETS[currentModel] || MODEL_PRESETS.veo2;

  // --- 各種State (続き) ---
  const [pricingInfo, setPricingInfo] = useState(null); // APIから取得した料金情報
  const [basePrice, setBasePrice] = useState(0); // 基本料金（秒単価）
  const [styleMultipliers, setStyleMultipliers] = useState({}); // スタイル別料金係数
  const [audioOptionsPricing, setAudioOptionsPricing] = useState({}); // 音声オプション追加料金
  const [settings, setSettings] = useState(currentPreset.defaultSettings); // 現在のユーザー設定
  const [currentPrice, setCurrentPrice] = useState(0); // 計算された現在の料金
  const [historyList, setHistoryList] = useState([]); // 生成履歴リスト
  const [isLoadingHistory, setIsLoadingHistory] = useState(false); // 履歴読み込み中フラグ
  const [selectedHistoryItem, setSelectedHistoryItem] = useState(null); // 選択中の履歴詳細
  const [snackbarOpen, setSnackbarOpen] = useState(false); // 通知表示フラグ
  const [snackbarMessage, setSnackbarMessage] = useState(''); // 通知メッセージ
  const [snackbarSeverity, setSnackbarSeverity] = useState('info'); // 通知タイプ
  const [paymentModalOpen, setPaymentModalOpen] = useState(false); // 決済モーダル表示フラグ
  const [paymentMethod, setPaymentMethod] = useState('stripe'); // 決済方法 (point/coin/ticket/stripe)
  const [point, setPoint] = useState(0); // ポイント残高
  const [coin, setCoin] = useState(0); // コイン残高
  const [ticketCount, setTicketCount] = useState(0); // チケット残高（全体）
  const [availableTicketCount, setAvailableTicketCount] = useState(0); // 利用可能チケット残高（条件に合致）
  const [availableTickets, setAvailableTickets] = useState([]); // 利用可能チケット一覧
  const {loginInfo, setLoginInfo} = useContext(LoginInfo); // ログイン情報
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false); // モバイル設定ダイアログ表示フラグ
  // --- State定義終了 ---


  // --- API連携関数 ---
  // useCallback: 関数をメモ化し、不要な再生成を防ぐ

  // ポイント残高を取得
  const fetchPoint = useCallback(async () => {
    try {
      const data = await apiClient.get('/point');
      if (data.result !== undefined) {
        setPoint(data.point);
      }
    } catch (error) {
      console.error("ポイント取得エラー:", error);
    }
  }, []);

  // コイン残高を取得
  const fetchCoin = useCallback(async () => {
    try {
      const data = await apiClient.get('/coin/coinInfo');
      if (data.result && data.data) {
        setCoin(data.data.coin || 0);
      }
    } catch (error) {
      console.error("コイン取得エラー:", error);
    }
  }, []);

  // チケット残高を取得
  const fetchTicketBalance = useCallback(async () => {
    try {
      const data = await apiClient.get('/generationTicket/balance/video');
      if (data.result) {
        setTicketCount(data.total_remaining || 0);
      }
    } catch (error) {
      console.error("チケット取得エラー:", error);
    }
  }, []);

  // 利用可能なチケット一覧を取得
  const fetchAvailableTickets = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        ticket_type: 'video',
        model: currentModel,
        duration: settings.durationSeconds.toString(),
        price: currentPrice.toString()
      });
      const data = await apiClient.get(`/generationTicket/available?${params}`);
      if (data.result && data.data) {
        setAvailableTickets(data.data);
        // 利用可能なチケットの合計枚数を計算
        const totalAvailable = data.data.reduce((sum, ticket) => sum + (ticket.remaining_count || 0), 0);
        setAvailableTicketCount(totalAvailable);
      } else {
        setAvailableTickets([]);
        setAvailableTicketCount(0);
      }
    } catch (error) {
      console.error("利用可能チケット取得エラー:", error);
      setAvailableTickets([]);
      setAvailableTicketCount(0);
    }
  }, [currentModel, settings.durationSeconds, currentPrice]);

  // 料金情報をAPIから取得
  const fetchPricingInfo = useCallback(async () => {
    try {
      const data = await apiClient.get('/videogen/pricing');
      if (data.result && data.data) {
        setPricingInfo(data.data); setBasePrice(data.data.basePrice || 0); setStyleMultipliers(data.data.styleMultipliers || {}); setAudioOptionsPricing(data.data.audioOptions || {});
      } else {
        console.error("料金情報取得失敗:", data); showSnackbar("料金情報の取得に失敗。", "error"); setBasePrice(100); setStyleMultipliers({ none: 1, realistic: 1, anime: 1, watercolor: 1, '3d': 1, cinematic: 1 }); setAudioOptionsPricing({ none: 0 });
      }
    } catch (error) {
      console.error("料金情報取得エラー:", error); showSnackbar(`料金情報取得エラー: ${error.message}`, "error"); setBasePrice(100); setStyleMultipliers({ none: 1, realistic: 1, anime: 1, watercolor: 1, '3d': 1, cinematic: 1 }); setAudioOptionsPricing({ none: 0 });
    }
  }, []); // 依存配列が空なので、マウント時に一度だけ実行される

  // 生成履歴をAPIから取得
  const fetchHistory = useCallback(async (preserveScroll = false) => {
    // スクロール位置を保存
    const scrollTop = preserveScroll && historyListRef.current ? historyListRef.current.scrollTop : 0;
    
    // preserveScrollがtrueの場合はローディング表示をスキップ（ちらつき防止）
    if (!preserveScroll) {
      setIsLoadingHistory(true);
    }
    console.log("履歴取得中...");
    try {
      const data = await apiClient.get('/videogen'); // GET /v1/videogen
      if (data.result && Array.isArray(data.data)) {
        console.log("履歴取得成功:", data.data.length, "件");
        setHistoryList(data.data);
        
        // スクロール位置を復元
        if (preserveScroll && historyListRef.current) {
          setTimeout(() => {
            if (historyListRef.current) {
              historyListRef.current.scrollTop = scrollTop;
            }
          }, 0);
        }
      } else {
        console.error("履歴取得失敗 or 不正データ:", data); setHistoryList([]); showSnackbar(data.errors?.join(', ') || "履歴取得失敗。", "error");
      }
    } catch (error) {
      console.error("履歴取得エラー:", error); setHistoryList([]); showSnackbar(`履歴取得エラー: ${error.message}`, "error"); if (error.message.includes("401")) { showSnackbar("履歴取得失敗。再ログイン要。", "error"); }
    } finally {
      if (!preserveScroll) {
        setIsLoadingHistory(false);
      }
      console.log("履歴取得完了。");
    }
  }, []); // 依存配列なし

  // 履歴詳細をAPIから取得
  const fetchHistoryDetail = useCallback(async (procId) => {
    // 同じアイテムが選択されたら詳細を閉じる（トグル動作）
    if (selectedHistoryItem?.proc_id === procId) { setSelectedHistoryItem(null); return; }
    try {
      const data = await apiClient.get(`/videogen/detail/${procId}`); // GET /v1/videogen/detail/{procId}
      if (data.result && data.data) {
        setSelectedHistoryItem(data.data); // 詳細データをStateにセット
      } else {
        showSnackbar(data.message || "詳細取得失敗。", "error"); setSelectedHistoryItem(null);
      }
    } catch (error) {
      console.error("詳細取得エラー:", error); showSnackbar(`詳細取得エラー: ${error.message}`, "error"); setSelectedHistoryItem(null);
    }
  }, [selectedHistoryItem]); // selectedHistoryItem が変わった場合に再生成

  // ポイント決済処理
  const handlePointPayment = useCallback(async () => {
    if (!pricingInfo || currentPrice <= 0) { showSnackbar("料金不正または計算中。", "warning"); return; }

    setPaymentModalOpen(false); // モーダルを閉じる
    setIsGenerating(true); // ローディング開始
    showSnackbar("動画生成リクエスト送信中...", "info");

    // バックエンドに渡すデータ
    const requestData = {
      prompt: prompt,
      model: currentModel,
      style: settings.style,
      aspectRatio: settings.aspectRatio,
      durationSeconds: settings.durationSeconds,
      frameRate: settings.frameRate,
      hasAudio: settings.hasAudio,
      audioType: settings.audioType,
      variationCount: settings.variationCount,
      publicFlg: settings.publicFlg,
      paymentMethod: paymentMethod, // ポイントまたはコイン
    };

    try {
      const response = await apiClient.post('/videogen', requestData);

      if (response.result) {
        showSnackbar("動画生成リクエストを受付けました！", "success");
        // ポイント/コイン/チケット残高を更新
        if (response.data?.afterPoint !== undefined) setPoint(response.data.afterPoint.point);
        if (response.data?.afterCoin !== undefined) setCoin(response.data.afterCoin);
        if (response.data?.afterTicket !== undefined) {
          setTicketCount(response.data.afterTicket);
          // チケット一覧も再取得
          fetchTicketBalance();
          fetchAvailableTickets();
        }
        // 履歴を更新
        fetchHistory();
        // プロンプトをクリア
        setPrompt('');
      } else {
        const errorMsg = response.errors?.join(', ') || "生成リクエスト失敗。";
        showSnackbar(errorMsg, "error");
      }
    } catch (error) {
      console.error("ポイント決済エラー:", error);
      showSnackbar(`生成エラー: ${error.message}`, "error");
    } finally {
      setIsGenerating(false);
    }
  }, [prompt, currentModel, settings, currentPrice, pricingInfo, paymentMethod, fetchHistory, fetchTicketBalance, fetchAvailableTickets]);

  // Stripe Checkout処理を開始
  const handleStripeCheckout = useCallback(async () => {
    if (!pricingInfo || currentPrice <= 0) { showSnackbar("料金不正または計算中。", "warning"); return; }
    const stripe = await stripePromise; // Stripe.jsのインスタンスを取得
    if (!stripe) { showSnackbar("決済システム読込失敗。", "error"); return; }

    setPaymentModalOpen(false); // モーダルを閉じる
    setIsGenerating(true); // ローディング開始
    showSnackbar("決済セッション作成中...", "info");

    // バックエンドに渡すデータ
    const checkoutRequestData = {
      price: currentPrice, // 計算済み料金
      generationParams: { // 生成パラメータ
        prompt: prompt, model: currentModel, style: settings.style, aspectRatio: settings.aspectRatio,
        durationSeconds: settings.durationSeconds, frameRate: settings.frameRate,
        hasAudio: settings.hasAudio, audioType: settings.audioType,
        variationCount: settings.variationCount, publicFlg: settings.publicFlg,
      }
    };

    try {
      // バックエンドAPI呼び出し (/stripe/createCheckoutSession)
      const sessionResponse = await apiClient.post('/stripe/createCheckoutSession', checkoutRequestData);

      if (sessionResponse.result && sessionResponse.sessionId) {
        // Stripe Checkoutページへリダイレクト
        showSnackbar("決済ページへ移動します...", "info");
        const { error } = await stripe.redirectToCheckout({ sessionId: sessionResponse.sessionId });
        if (error) { // リダイレクト失敗
          console.error("Stripeリダイレクトエラー:", error); showSnackbar(`決済ページ移動失敗: ${error.message}`, "error"); setIsGenerating(false);
        }
      } else {
        // セッション作成失敗
        console.error("セッション作成失敗:", sessionResponse); showSnackbar(sessionResponse.errors?.join(', ') || "決済セッション作成失敗。", "error"); setIsGenerating(false);
      }
    } catch (error) {
      // API呼び出し自体のエラー
      console.error("セッション作成APIエラー:", error); showSnackbar(`決済セッション作成エラー: ${error.message}`, "error"); setIsGenerating(false);
    }
  }, [prompt, settings, currentPrice, pricingInfo]); // 依存するstateや変数を指定

  // 生成リクエストキャンセル処理
  const handleCancelRequest = useCallback(async (procId, e) => {
      e.stopPropagation(); // ListItemクリックイベントの伝播を停止
      if (!window.confirm(`リクエストID: ${procId.substring(0,8)}... をキャンセルしますか？\n(処理開始後はキャンセルできません)`)) return;
      showSnackbar(`リクエスト ${procId.substring(0,8)}... をキャンセル中...`, "info");
      try {
          const data = await apiClient.post(`/videogen/cancel/${procId}`); // POST /v1/videogen/cancel/{procId}
          if (data.result) {
              showSnackbar(data.message || "キャンセルしました。", "success"); fetchHistory(); // 履歴更新
              if (selectedHistoryItem?.proc_id === procId) setSelectedHistoryItem(null); // 詳細表示中なら閉じる
          } else {
              showSnackbar(data.message || "キャンセル失敗。", "error");
          }
      } catch (error) {
          console.error("キャンセルAPIエラー:", error); showSnackbar(`キャンセルエラー: ${error.message}`, "error");
      }
  }, [fetchHistory, selectedHistoryItem]); // fetchHistory, selectedHistoryItem に依存
  // --- API連携関数終了 ---


  // --- useEffectフック ---
  // マウント時に料金情報と履歴を取得
  useEffect(() => { fetchPricingInfo(); fetchHistory(); fetchPoint(); fetchCoin(); fetchTicketBalance(); }, [fetchPricingInfo, fetchHistory, fetchPoint, fetchCoin, fetchTicketBalance]);

  // 定期的に履歴を更新（30秒ごと、スクロール位置保持）
  useEffect(() => {
    const intervalId = setInterval(() => {
      console.log("定期履歴更新を実行");
      fetchHistory(true); // スクロール位置を保持して更新
    }, 30000); // 30秒ごと

    return () => clearInterval(intervalId); // クリーンアップ
  }, [fetchHistory]);

  // モデル変更時に設定をリセット
  useEffect(() => { 
    const newDefaults = MODEL_PRESETS[currentModel]?.defaultSettings || MODEL_PRESETS.veo2.defaultSettings; 
    // Sora 2系の場合は音声を常にオンにする
    if (currentModel === 'sora-2' || currentModel === 'sora-2-pro') {
      newDefaults.hasAudio = true;
    }
    setSettings(newDefaults); 
  }, [currentModel]);

  // モデル、設定、料金が変更されたら利用可能チケットを再取得（debounce付き）
  useEffect(() => {
    // チケット決済が選択されている場合のみ取得
    // paymentMethodは依存配列から除外（モーダルオープン時に取得するため）
    if (paymentMethod !== "ticket" || !currentModel || !settings.durationSeconds || currentPrice <= 0) {
      return;
    }

    // 短時間に複数回呼ばれるのを防ぐためのタイマー
    const timerId = setTimeout(() => {
      fetchAvailableTickets();
    }, 300); // 300ms待機

    // クリーンアップ: 次の実行前に前のタイマーをキャンセル
    return () => clearTimeout(timerId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModel, settings.durationSeconds, currentPrice]);

  // 決済方法変更時に公開設定を自動調整
  useEffect(() => {
    // ポイント、チケット使用時は公開のみ（publicFlg = true）
    if (paymentMethod === 'point' || paymentMethod === 'ticket') {
      if (!settings.publicFlg) {
        setSettings(prev => ({ ...prev, publicFlg: true }));
      }
    }
    // コイン、Stripeは選択可能（変更しない）
  }, [paymentMethod, settings.publicFlg]);

  // 料金計算 (useCallbackでメモ化)
  const calculatePrice = useCallback(() => {
      // sora-2 と sora-2-pro は固定料金
      if (currentModel === 'sora-2' || currentModel === 'sora-2-pro') {
          const modelPreset = MODEL_PRESETS[currentModel];
          if (modelPreset && modelPreset.pricing) {
              const duration = settings.durationSeconds;
              const fixedPrice = modelPreset.pricing[duration];
              if (typeof fixedPrice === 'number') {
                  return fixedPrice * settings.variationCount;
              }
          }
          return 0;
      }
      
      // veo2 は従来の計算方式
      if (!pricingInfo || basePrice === 0) return 0;
      const modelBasePrice = basePrice;
      const duration = settings.durationSeconds;
      const variations = settings.variationCount;
      // style='none' の場合は係数1とする
      const styleMultiplierValue = settings.style === 'none' ? 1.0 : styleMultipliers[settings.style];
      const safeStyleMultiplier = (typeof styleMultiplierValue === 'number' && !isNaN(styleMultiplierValue)) ? styleMultiplierValue : 1.0;
      let totalPrice = modelBasePrice * duration * safeStyleMultiplier;
      totalPrice *= variations;
      let audioAddition = 0;
      if (settings.hasAudio && settings.audioType !== 'none') {
          const audioPrice = audioOptionsPricing[settings.audioType];
          audioAddition = (typeof audioPrice === 'number' && !isNaN(audioPrice)) ? audioPrice : 0;
      }
      totalPrice += audioAddition;
      return Math.round(totalPrice);
  }, [settings, pricingInfo, basePrice, styleMultipliers, audioOptionsPricing, currentModel]); // 計算に必要な値に依存

  // 料金を再計算してStateに反映
  useEffect(() => { setCurrentPrice(calculatePrice()); }, [calculatePrice]); // calculatePriceのメモ化結果に依存
  // タイトルを設定
  useEffect(() => {
    let tmpTitle = "動画生成 - AI活用プラットフォーム「ourt AI」";
    document.title = tmpTitle; // タイトルを更新
  }, []);
  // --- useEffectフック終了 ---


  // --- ヘルパー関数 & モーダル制御 ---
  // Snackbar表示
  const showSnackbar = (message, severity = 'info') => { setSnackbarMessage(message); setSnackbarSeverity(severity); setSnackbarOpen(true); };
  // Snackbar非表示
  const handleSnackbarClose = (event, reason) => { if (reason === 'clickaway') return; setSnackbarOpen(false); };
  // タブ切り替え
  const handleTabChange = (event, newValue) => { setTabValue(newValue); };
  // 設定値変更
  const handleSettingChange = (setting, value) => {
    setSettings(prevSettings => {
        let processedValue = value;
        // 数値項目は数値に変換
        if (['durationSeconds', 'frameRate', 'variationCount', 'motionStrength'].includes(setting)) {
            processedValue = parseInt(value, 10); if (isNaN(processedValue)) processedValue = prevSettings[setting];
        }
        const newSettings = { ...prevSettings, [setting]: processedValue };
        // 音声有無とタイプを連動
        if (setting === 'hasAudio') { newSettings.audioType = value ? (prevSettings.audioType === 'none' ? 'ambient' : prevSettings.audioType) : 'none'; }
        if (setting === 'audioType') { if (value === 'none') { newSettings.hasAudio = false; } else { newSettings.hasAudio = true; } }
        return newSettings;
    });
  };
  // 決済モーダルを開く
  const handleOpenPaymentModal = async () => {
     if (!prompt.trim()) { showSnackbar("プロンプトを入力してください。", "warning"); return; }
     if (!pricingInfo || currentPrice <= 0) { showSnackbar("料金計算中か生成内容がありません。", "warning"); return; }
     
     // モーダルを開く前に最新のチケット数を取得（1回のAPI呼び出し）
     try {
       const params = new URLSearchParams({
         ticket_type: 'video',
         model: currentModel,
         duration: settings.durationSeconds.toString(),
         price: currentPrice.toString()
       });
       const data = await apiClient.get(`/generationTicket/available?${params}`);
       if (data.result && data.data) {
         // Stateを更新
         setAvailableTickets(data.data);
         const totalAvailable = data.data.reduce((sum, ticket) => sum + (ticket.remaining_count || 0), 0);
         setAvailableTicketCount(totalAvailable);
         
         // チケットがある場合は自動選択
         if (totalAvailable > 0) {
           setPaymentMethod('ticket');
         }
       } else {
         setAvailableTickets([]);
         setAvailableTicketCount(0);
       }
     } catch (error) {
       console.error("チケット取得エラー:", error);
       setAvailableTickets([]);
       setAvailableTicketCount(0);
     }
     
     setPaymentModalOpen(true);
  };
  // 決済モーダルを閉じる
  const handleClosePaymentModal = () => { setPaymentModalOpen(false); };
  // --- ヘルパー関数終了 ---


  // ================== JSXレンダリング ==================
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', m: 0, p: 0 }}>
      {/* ヘッダー */}
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Box 
            sx={{ 
              flexGrow: 1, 
              cursor: 'pointer',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' }, // モバイルで縦並び
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: { xs: 0, md: 1 }
            }} 
            onClick={() => navigate('/')}
          >
            <img src='/img/logo_new.png' height={18} alt="logo" />
            <Typography variant="h6" component="div" sx={{ fontSize: { xs: 12, md: 14 } }}>
              動画生成
            </Typography>
          </Box>
          {/* モデル選択 */}
          <FormControl sx={{ minWidth: 150, mr: 1 }} size="small"> {/* display:none で非表示 */}
            <InputLabel id="model-select-label">モデル</InputLabel>
            <Select labelId="model-select-label" value={currentModel} label="モデル" onChange={(e) => setCurrentModel(e.target.value)}>
              {Object.keys(MODEL_PRESETS).map((k) => ( <MenuItem key={k} value={k}>{MODEL_PRESETS[k].name}</MenuItem> ))}
            </Select>
          </FormControl>
          {/* 更新ボタン */}
          <IconButton color="inherit" onClick={() => fetchHistory(true)} title="履歴更新"><RefreshIcon /></IconButton>
          {/* 設定ボタン (無効) */}
          <IconButton color="inherit" title="設定" disabled><SettingsIcon /></IconButton>
        </Toolbar>
      </AppBar>

      {/* メインコンテンツ */}
      <Box sx={{ 
        display: 'flex', 
        flexGrow: 1, 
        overflow: 'hidden',
        flexDirection: { xs: 'column-reverse', md: 'row' }, // モバイル時は縦方向（設定が下）、デスクトップ時は横方向
        m: 0,
        p: 0
      }}>
        {/* 左サイドバー: 設定 (デスクトップのみフル表示) */}
        <Paper elevation={0} sx={{ 
          width: { xs: '100%', md: 360 }, // モバイル時は幅100%、デスクトップ時は360px
          height: { xs: 'auto', md: 'auto' }, // モバイル時は自動高さ
          borderRight: { xs: 'none', md: `1px solid ${theme.palette.divider}` }, // モバイル時はボーダーなし
          borderTop: { xs: `1px solid ${theme.palette.divider}`, md: 'none' }, // モバイル時は上部ボーダー
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'hidden', // 余白を防ぐ
          flexShrink: 0 // モバイル時に縮小されないようにする
        }}>
          {/* タブ (デスクトップのみ表示) */}
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth" indicatorColor="primary" textColor="primary" sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Tab label="文字から動画" icon={<WandIcon />} iconPosition="start" />
            <Tab label="画像から動画" icon={<UploadIcon />} iconPosition="start" disabled />
          </Tabs>

          {/* モバイル専用: プロンプト入力 + 設定ボタン */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, p: 1, gap: 1, alignItems: 'flex-start' }}>
            <TextField 
              label="プロンプト" 
              multiline 
              rows={2} 
              placeholder="動画の内容..." 
              fullWidth 
              variant="outlined" 
              value={prompt} 
              onChange={(e) => setPrompt(e.target.value)} 
              required 
              size="small"
            />
            <IconButton 
              color="primary" 
              onClick={() => setSettingsDialogOpen(true)}
              sx={{ 
                bgcolor: 'primary.main', 
                color: 'white',
                '&:hover': { bgcolor: 'primary.dark' },
                mt: 0.5
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>

          {/* 設定項目スクロールエリア (デスクトップのみ) */}
          <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden', m: 0, p: 0, display: { xs: 'none', md: 'block' } }}>
            <TabPanel value={tabValue} index={0}>
              <Stack spacing={2}>
                {/* プロンプト */}
                <TextField label="プロンプト" multiline rows={4} placeholder="動画の内容..." fullWidth variant="outlined" value={prompt} onChange={(e) => setPrompt(e.target.value)} required size="small"/>
                {/* スタイル */}
                {(currentModel !== 'sora-2' && currentModel !== 'sora-2-pro') && (
                <FormControl fullWidth required size="small">
                  <InputLabel>スタイル</InputLabel>
                  <Select value={settings.style} onChange={(e) => handleSettingChange('style', e.target.value)} label="スタイル">
                    {currentPreset.availableStyles.map((s) => ( <MenuItem key={s.value} value={s.value}>{s.label} {(styleMultipliers[s.value] ?? 1.0) > 1.0 ? ` (+${(( (styleMultipliers[s.value] ?? 1.0) - 1) * 100).toFixed(0)}%)` : ''}</MenuItem> ))}
                  </Select>
                </FormControl>
                )}
                {/* 縦横比 (ビジュアルセレクタ) */}
                <Box>
                  <Typography variant="caption" display="block" gutterBottom color="text.secondary" sx={{mb: 0.5}}>縦横比</Typography>
                  <Grid container spacing={1}>{currentPreset.availableAspectRatios.map((ratio) => { const isSelected = settings.aspectRatio === ratio.value; const aspectVal = ratio.width / ratio.height; let pH = '40px'; let pW = `${40 * aspectVal}px`; if (aspectVal < 1) { pW = '40px'; pH = `${40 / aspectVal}px`; } const maxW = '55px'; const maxH = '55px'; if (parseFloat(pW) > parseFloat(maxW)) { pH = `${parseFloat(pH) * (parseFloat(maxW) / parseFloat(pW))}px`; pW = maxW; } if (parseFloat(pH) > parseFloat(maxH)) { pW = `${parseFloat(pW) * (parseFloat(maxH) / parseFloat(pH))}px`; pH = maxH; } return ( <Grid item key={ratio.value}><Paper onClick={() => handleSettingChange('aspectRatio', ratio.value)} variant="outlined" sx={{ p: 0.5, textAlign: 'center', cursor: 'pointer', borderColor: isSelected ? theme.palette.primary.main : theme.palette.divider, borderWidth: isSelected ? '2px' : '1px', bgcolor: 'transparent', '&:hover': { bgcolor: theme.palette.action.hover, borderColor: theme.palette.primary.light }, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: '70px' }} ><Box sx={{ width: pW, height: pH, bgcolor: isSelected ? theme.palette.primary.lighter : theme.palette.grey[200], border: `1px solid ${isSelected ? theme.palette.primary.light : theme.palette.grey[300]}`, borderRadius: '2px', mb: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }} /><Typography variant="caption" display="block" sx={{lineHeight: 1.1}}>{ratio.label}</Typography><Typography variant="caption" color="text.secondary" sx={{lineHeight: 1.1}}>({ratio.value})</Typography></Paper></Grid> ); })}</Grid>
                </Box>
                {/* 動画の長さ */}
                <FormControl fullWidth required size="small"><InputLabel>動画の長さ</InputLabel><Select value={settings.durationSeconds} onChange={(e) => handleSettingChange('durationSeconds', e.target.value)} label="動画の長さ">{currentPreset.availableVideoLengths.map((l) => ( <MenuItem key={l.value} value={l.value}>{l.label}</MenuItem> ))}</Select></FormControl>
                {/* 生成数 */}
                <FormControl fullWidth required size="small"><InputLabel>生成数</InputLabel><Select value={settings.variationCount} onChange={(e) => handleSettingChange('variationCount', e.target.value)} label="生成数">{currentPreset.availableVariationCounts.map((c) => ( <MenuItem key={c.value} value={c.value}>{c.label} {c.value > 1 ? `(料金 ×${c.value})` : ''}</MenuItem> ))}</Select></FormControl>
                {/* 詳細設定 */}
                <Button variant="text" size="small" endIcon={showAdvancedOptions ? <ExpandMoreIcon sx={{ transform: 'rotate(180deg)' }} /> : <ExpandMoreIcon />} onClick={() => setShowAdvancedOptions(!showAdvancedOptions)} sx={{ justifyContent: 'flex-start', color: 'text.secondary', p:0}}>詳細設定</Button>
                {showAdvancedOptions && ( <Box sx={{ pt: 1, pl: 1, borderLeft: `3px solid ${theme.palette.divider}`, ml:1 }}><Stack spacing={2}>
                    <FormControl fullWidth size="small"><InputLabel>フレームレート</InputLabel><Select value={settings.frameRate} label="フレームレート" disabled={currentModel === 'veo2'}>{currentPreset.availableFrameRates.map((r) => ( <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem> ))}</Select><Typography variant="caption" color="text.secondary" sx={{mt:0.5}}>({currentModel === 'veo2' ? '24fpsのみ' : 'モデル依存'})</Typography></FormControl>
                    {(currentModel === 'sora-2' || currentModel === 'sora-2-pro') ? (
                      <Box sx={{ p: 1.5, bgcolor: 'info.lighter', borderRadius: 1, border: `1px solid ${theme.palette.info.light}` }}>
                        <Typography variant="body2" color="info.main" sx={{ display: 'flex', alignItems: 'center' }}>
                          <InfoIcon fontSize="small" sx={{ mr: 0.5 }} />
                          音声追加は常時オンです
                        </Typography>
                      </Box>
                    ) : (
                      <FormControl component="fieldset" variant="standard"><FormControlLabel control={<Switch checked={settings.hasAudio} onChange={(e) => handleSettingChange('hasAudio', e.target.checked)} size="small"/>} label="音声追加"/>{settings.hasAudio && ( <Select value={settings.audioType} onChange={(e) => handleSettingChange('audioType', e.target.value)} size="small" sx={{ mt: 0.5 }} displayEmpty><MenuItem value="none" disabled><em>音声タイプ</em></MenuItem>{currentPreset.availableAudioOptions.filter(o => o.value !== 'none').map((o) => ( <MenuItem key={o.value} value={o.value}>{o.label} {audioOptionsPricing[o.value] ? ` (+${audioOptionsPricing[o.value].toLocaleString()}円)` : ''}</MenuItem> ))}</Select> )}</FormControl>
                    )}
                </Stack></Box> )}
              </Stack>
            </TabPanel>
            {/* Image to Video タブ(プレースホルダー) */}
            <TabPanel value={tabValue} index={1}> <Stack spacing={3}><Paper variant="outlined" sx={{ p: 3, textAlign: 'center', borderStyle: 'dashed', cursor: 'not-allowed', bgcolor: 'grey.100' }}><UploadIcon color="disabled" sx={{ fontSize: 30, mb: 1 }} /><Typography variant="body2" color="text.secondary" gutterBottom>画像から動画生成（準備中）</Typography><Button variant="outlined" size="small" sx={{ mt: 1 }} disabled>ファイル選択</Button></Paper><Box><Typography gutterBottom variant="caption">モーション強度(未実装)</Typography><Slider value={settings.motionStrength} disabled size="small"/></Box><Typography variant="body2" color="text.secondary" align="center">現在利用できません。</Typography></Stack> </TabPanel>
          </Box>
          {/* 生成ボタン (デスクトップのみ) */}
          <Box sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}`, display: { xs: 'none', md: 'block' } }}>
            <Button variant="contained" size="large" fullWidth onClick={handleOpenPaymentModal} disabled={isGenerating || !prompt.trim() || ((currentModel !== 'sora-2' && currentModel !== 'sora-2-pro') && !pricingInfo) || (currentPrice || 0) <= 0} startIcon={<WandIcon />} sx={{ py: 1.2 }}>
              生成
            </Button>
            {isGenerating && ( <LinearProgress sx={{ mt: 1 }} /> )}
          </Box>

          {/* モバイル専用: 生成ボタン */}
          <Box sx={{ p: 1, display: { xs: 'block', md: 'none' } }}>
            <Button 
              variant="contained" 
              size="large" 
              fullWidth 
              onClick={handleOpenPaymentModal} 
              disabled={isGenerating || !prompt.trim() || ((currentModel !== 'sora-2' && currentModel !== 'sora-2-pro') && !pricingInfo) || (currentPrice || 0) <= 0} 
              startIcon={<WandIcon />} 
              sx={{ py: 1.5 }}
            >
              生成
            </Button>
            {isGenerating && ( <LinearProgress sx={{ mt: 1 }} /> )}
          </Box>
        </Paper>

        {/* 右側メインエリア: 履歴と詳細 */}
        <Box sx={{ 
          flexGrow: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          p: { xs: 0.5, md: 2 }, // モバイル時はパディングをほぼゼロに
          overflow: 'hidden', 
          bgcolor: theme.palette.grey[100],
          m: 0, // マージンを完全にゼロに
          maxHeight: { xs: 'calc(100vh - 56px - 120px)', md: '100%' } // モバイル時はヘッダーとプロンプトエリア分を引く
        }}>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                display: { xs: 'none', md: 'flex' }, // モバイル時は非表示
                alignItems: 'center' 
              }}
            >
              <HistoryIcon sx={{ mr: 1 }}/> 生成履歴
            </Typography>
            {/* 履歴Loading/Empty/List */}
            {isLoadingHistory ? ( 
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress />
              </Box> 
            ) : historyList.length === 0 ? ( 
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', textAlign: 'center' }}>
                <VideocamIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
                <Typography color="text.secondary">履歴なし</Typography>
                <Typography variant="caption" color="text.secondary">動画を生成すると表示</Typography>
              </Box> 
            ) : ( 
              <Box 
                ref={historyListRef}
                sx={{ flexGrow: 1, overflowY: 'auto', mr: { xs: 0, md: -1 }, pr: { xs: 0, md: 1 } }}
              > 
                <List dense disablePadding> 
                  {historyList.map((item) => ( 
                    <ListItem 
                      key={item.proc_id} 
                      divider 
                      disablePadding 
                      secondaryAction={
                        <Stack direction="row" spacing={{ xs: 0.2, md: 0.5 }} alignItems="center">
                          {/* 鍵マーク (デスクトップのみ) */}
                          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                            {item.public_flg ? <PublicIcon fontSize="small" titleAccess="公開"/> : <PrivateIcon fontSize="small" titleAccess="非公開"/>}
                          </Box>
                          {/* ステータスチップ */}
                          {getStatusChip(item.status)}
                          {/* キャンセルボタン (デスクトップのみ) */}
                          {item.status === 0 && (
                            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                              <IconButton edge="end" onClick={(e) => handleCancelRequest(item.proc_id, e)} size="small" title="キャンセル">
                                <CancelIcon fontSize="small"/>
                              </IconButton>
                            </Box>
                          )}
                          {/* 詳細ボタン */}
                          <IconButton edge="end" onClick={() => fetchHistoryDetail(item.proc_id)} size="small" title="詳細">
                            <InfoIcon fontSize="small"/>
                          </IconButton>
                        </Stack>
                      } 
                      sx={{ 
                        bgcolor: selectedHistoryItem?.proc_id === item.proc_id ? theme.palette.action.selected : theme.palette.background.paper, 
                        mb: 0.5, 
                        borderRadius: 1, 
                        cursor:'pointer', 
                        '&:hover': { bgcolor: theme.palette.action.hover }, 
                        py: 0.5 
                      }} 
                      onClick={() => fetchHistoryDetail(item.proc_id)}
                    > 
                      <ListItemText 
                        primary={
                          <Typography variant="body2" noWrap sx={{maxWidth: { xs: 'calc(100% - 100px)', md: 'calc(100% - 160px)' }}} title={item.prompt}> 
                            {item.prompt || '(No Prompt)'} 
                          </Typography> 
                        } 
                        secondary={
                          <Typography variant="caption" color="text.secondary" noWrap sx={{maxWidth: { xs: 'calc(100% - 100px)', md: 'calc(100% - 160px)' }}}> 
                            {new Date(item.create_datetime).toLocaleString('sv-SE')} {' / '} {item.model || 'Veo 2'}
                          </Typography> 
                        } 
                      /> 
                    </ListItem> 
                  ))} 
                </List> 
              </Box> 
            )}
             {/* 選択された履歴の詳細表示 (デスクトップのみ) */}
             {selectedHistoryItem && (
               <Paper elevation={2} sx={{ p: 1.5, mt: 1.5, overflowY: 'auto', maxHeight: '45%', display: { xs: 'none', md: 'block' } }}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                   <Typography variant="subtitle2" noWrap sx={{maxWidth: '80%'}}> 詳細: {selectedHistoryItem.prompt || '(No Prompt)'} </Typography>
                   <IconButton size="small" onClick={() => setSelectedHistoryItem(null)} title="閉じる"><CloseIcon fontSize='small'/></IconButton>
                 </Box>
                 <Grid container spacing={1.5}>
                   <Grid item xs={12} md={6}> {/* 左列: 情報 */}
                     <Typography variant="caption">ID: {selectedHistoryItem.proc_id}</Typography><br/>
                     <Typography variant="caption">Status: {getStatusChip(selectedHistoryItem.status)}</Typography><br/>
                     <Typography variant="caption">作成: {new Date(selectedHistoryItem.create_datetime).toLocaleString()}</Typography><br/>
                     {selectedHistoryItem.generate_start_datetime && <><Typography variant="caption">開始: {new Date(selectedHistoryItem.generate_start_datetime).toLocaleString()}</Typography><br/></>}
                     {selectedHistoryItem.generate_end_datetime && <><Typography variant="caption">完了: {new Date(selectedHistoryItem.generate_end_datetime).toLocaleString()}</Typography><br/></>}
                     {selectedHistoryItem.progress > 0 && selectedHistoryItem.status === 1 && <LinearProgress variant="determinate" value={selectedHistoryItem.progress} sx={{mt:0.5, height: 2, borderRadius: 1}}/>}
                     {selectedHistoryItem.error_message && <Alert severity="error" sx={{mt:1, p:0.5, fontSize: '0.75rem'}}>{selectedHistoryItem.error_message}</Alert>}
                   </Grid>
                   <Grid item xs={12} md={6}> {/* 右列: 設定 */}
                     <Typography variant="caption">設定: {selectedHistoryItem.style}, {selectedHistoryItem.aspect_ratio}, {selectedHistoryItem.duration_seconds}s, {selectedHistoryItem.variation_count}枚</Typography><br/>
                     <Typography variant="caption">音声: {selectedHistoryItem.has_audio ? selectedHistoryItem.audio_type || 'あり' : 'なし'}</Typography><br/>
                     <Typography variant="caption">料金: {selectedHistoryItem.price?.toLocaleString()}円</Typography><br/>
                     <Typography variant="caption">公開: {selectedHistoryItem.public_flg ? 'はい' : 'いいえ'}</Typography><br/>
                     {/* ★ ファイルパスは複数表示しない (formatFilePathは最初のもののみ表示) */}
                     <Typography variant="caption">ファイル: {formatFilePath(selectedHistoryItem.file_path, selectedHistoryItem.proc_id)}</Typography>
                   </Grid>
                   {/* ★★★ 複数動画プレビュー表示 ★★★ */}
                   {selectedHistoryItem.status === 2 && selectedHistoryItem.file_path && Array.isArray(selectedHistoryItem.file_path) && selectedHistoryItem.file_path.length > 0 && (
                     <Grid item xs={12}>
                       <Typography variant="caption" sx={{ mt: 0.5, display:'block' }}>プレビュー:</Typography>
                       <Grid container spacing={1}>
                         {/* file_path配列をループして各動画を表示 */}
                         {selectedHistoryItem.file_path.map((videoFile, index) => (
                           // variationCountに応じてGridサイズを調整 (例: 1,2枚ならxs=6, 3,4枚ならxs=3)
                           <Grid item xs={12} sm={selectedHistoryItem.variation_count <= 2 ? 6 : 3} key={index}>
                              {videoFile.path ? (
                                 <video
                                     // keyをproc_idとindexの組み合わせにして再描画を確実にする
                                     key={`${selectedHistoryItem.proc_id}_${index}`}
                                     src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST+`/generated/${videoFile.path}`} // サーバーパスに合わせて調整
                                     controls
                                     loop
                                     playsInline
                                     style={{ width: '100%', maxHeight: '180px', borderRadius: '4px', backgroundColor:'#eee', display: 'block' }}
                                     onError={(e) => { console.error(`Video ${index+1} load error:`, e); }}
                                 >
                                     動画読込失敗 {index + 1}
                                 </video>
                              ) : (
                                 <Paper sx={{ height: '100px', display:'flex', alignItems:'center', justifyContent:'center', bgcolor:'grey.200' }}>
                                      <Typography variant="caption" color="text.secondary">パス無効 {index + 1}</Typography>
                                 </Paper>
                              )}
                              {/* 必要ならファイル名やMIMEタイプも表示 */}
                               <Typography variant="caption" display="block" align="center" noWrap title={videoFile.path?.split('/').pop()}>
                                   {videoFile.path?.split('/').pop() || `動画 ${index + 1}`}
                               </Typography>
                           </Grid>
                         ))}
                       </Grid>
                     </Grid>
                   )}
                   {/* ★★★ 複数動画プレビュー表示終了 ★★★ */}

                   {/* ★★★ 複数ダウンロードリンク表示 ★★★ */}
                   {selectedHistoryItem.status === 2 && selectedHistoryItem.file_path && Array.isArray(selectedHistoryItem.file_path) && selectedHistoryItem.file_path.length > 0 && (
                        <Grid item xs={12}>
                            <Typography variant="caption" sx={{ mt: 1, display:'block' }}>ダウンロード:</Typography>
                            <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap' }}> {/* 横並び、折り返しあり */}
                                {selectedHistoryItem.file_path.map((videoFile, index) => (
                                    videoFile.path ? (
                                        <Button
                                            key={`download-${index}`}
                                            variant="outlined"
                                            size="small"
                                            href={ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST+`/generated/${videoFile.path}`} // 動画ファイルへのパス
                                            download={videoFile.path.split('/').pop() || `video_${selectedHistoryItem.proc_id}_${index+1}.mp4`} // download属性でファイル名を指定
                                            startIcon={<DownloadIcon />}
                                            sx={{ textTransform: 'none' }} // ファイル名の大文字化を防ぐ
                                        >
                                            {/* ボタンテキストにファイル名（省略形） */}
                                            {(`動画 ${index + 1}`)}
                                        </Button>
                                    ) : null // パスがない場合はボタンを表示しない
                                ))}
                            </Stack>
                        </Grid>
                   )}
                   {/* ★★★ 複数ダウンロードリンク表示終了 ★★★ */}
                 </Grid>
               </Paper>
             )}
        </Box>
      </Box>

      {/* 決済方法選択モーダル */}
      <Dialog 
        open={paymentModalOpen} 
        onClose={handleClosePaymentModal} 
        aria-labelledby="payment-dialog-title" 
        aria-describedby="payment-dialog-description"
        fullScreen={isMobile} // モバイルで全画面
        maxWidth="sm" // デスクトップでは最大幅sm
        fullWidth
      >
        <DialogTitle id="payment-dialog-title">
          お支払い方法選択
          <IconButton 
            aria-label="close" 
            onClick={handleClosePaymentModal} 
            sx={{ position: 'absolute', right: 8, top: 8, color: (t) => t.palette.grey[500] }} 
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="payment-dialog-description" sx={{ mb: 2 }}>生成内容をご確認の上、お支払い方法を選択してください。</DialogContentText>
          <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Typography variant="body2"><strong>プロンプト:</strong> {prompt}</Typography>
            <Typography variant="body2"><strong>スタイル:</strong> {currentPreset.availableStyles.find(s => s.value === settings.style)?.label || settings.style}</Typography>
            <Typography variant="body2"><strong>長さ:</strong> {settings.durationSeconds}秒</Typography>
            <Typography variant="body2"><strong>枚数:</strong> {settings.variationCount}枚</Typography>
          </Paper>
          <Typography variant="h6" align="center" sx={{ mb: 3 }}>
            合計金額: <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
              {(paymentMethod === 'ticket' || paymentMethod === 'point') ? '0' : (currentPrice || 0).toLocaleString()}円
            </span>
          </Typography>
          

          
          {/* 決済方法セレクター */}
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, gap: 2 }}>
            <Typography variant="h6">お支払い方法:</Typography>
            <PaymentMethodSelector 
              value={paymentMethod}
              pointCost={(currentPrice || 0) * 200}
              coinCost={currentPrice || 0}
              modelType={currentModel}
              availableTicketCount={availableTicketCount}
              onChange={(method) => setPaymentMethod(method)}
            />
          </Box>

          {/* 公開設定 - ポイント/チケット使用時は公開のみ */}
          <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>公開設定</Typography>
              {(paymentMethod === 'point' || paymentMethod === 'ticket') && (
                <Tooltip 
                  title="ポイント・チケット決済の場合は公開のみとなります" 
                  placement="top"
                  arrow
                >
                  <IconButton size="small" sx={{ ml: 0.5, p: 0.5 }}>
                    <InfoIcon fontSize="small" color="action" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <FormControlLabel 
              control={
                <Switch 
                  checked={settings.publicFlg} 
                  onChange={(e) => handleSettingChange('publicFlg', e.target.checked)} 
                  icon={<PrivateIcon />} 
                  checkedIcon={<PublicIcon />} 
                  size="small"
                  disabled={paymentMethod === 'point' || paymentMethod === 'ticket'}
                />
              } 
              label={settings.publicFlg ? "公開" : "非公開"} 
              sx={{justifyContent: 'flex-start', ml: 0}}
            />
            {!(paymentMethod === 'point' || paymentMethod === 'ticket') && (
              <Typography variant="caption" color="text.secondary" display="block" sx={{mt: 0.5, ml: 4}}>
                ※ 公開すると他のユーザーも閲覧できます
              </Typography>
            )}
          </Box>

          {/* 残高表示 */}
          {(paymentMethod === 'point' || paymentMethod === 'coin' || paymentMethod === 'ticket') && (
            <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
              <Typography variant="body2"><strong>現在の残高:</strong></Typography>
              <Typography variant="body2">ポイント: {(point || 0).toLocaleString()}</Typography>
              <Typography variant="body2">コイン: {(coin || 0).toLocaleString()}</Typography>
              <Typography variant="body2">
                チケット: {(availableTicketCount || 0).toLocaleString()}回利用可能
                {ticketCount !== availableTicketCount && (
                  <span style={{ color: '#666', fontSize: '0.9em' }}> (全{ticketCount || 0}回)</span>
                )}
              </Typography>
              {paymentMethod === 'ticket' && availableTicketCount === 0 && ticketCount > 0 && (
                <Typography variant="caption" color="warning.main">
                  ※ 現在の条件（モデル: {currentModel}, 時間: {settings.durationSeconds}秒）に合致するチケットがありません
                </Typography>
              )}
            </Paper>
          )}
          
          {/* 生成ボタン (デスクトップのみここに表示) */}
          <Stack spacing={2} direction="column" alignItems="stretch" sx={{ display: { xs: 'none', md: 'flex' } }}>
            {paymentMethod === 'point' ? (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || point < (currentPrice || 0) * 200}
              >
                ポイントで生成 ({((currentPrice || 0) * 200).toLocaleString()}pt)
                {point < (currentPrice || 0) * 200 && ' (残高不足)'}
              </Button>
            ) : paymentMethod === 'coin' ? (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || coin < Math.ceil((currentPrice || 0) / 10)}
              >
                コインで生成 ({Math.ceil(currentPrice || 0).toLocaleString()}コイン)
                {coin < Math.ceil(currentPrice || 0) && ' (残高不足)'}
              </Button>
            ) : paymentMethod === 'ticket' ? (
              <Button 
                variant="contained" 
                color="success" 
                size="large" 
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || availableTicketCount === 0}
              >
                チケットで生成 (残り{availableTicketCount || 0}回)
                {availableTicketCount === 0 && ticketCount > 0 && ' (条件不一致)'}
                {ticketCount === 0 && ' (チケットなし)'}
              </Button>
            ) : (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                startIcon={<CreditCardIcon />} 
                onClick={handleStripeCheckout} 
                disabled={isGenerating}
              >
                クレジットカードで生成 ({(currentPrice || 0).toLocaleString()}円)
              </Button>
            )}
          </Stack>
          
          {/* 返金に関する注意書き */}
          <Paper variant="outlined" sx={{ p: 2, mt: 2, mb: 2, bgcolor: '#fff3cd', borderColor: '#ffeaa7' }}>
            <Typography variant="body2" sx={{ color: '#856404', fontWeight: 'bold', mb: 1 }}>
              ⚠️ 重要なお知らせ
            </Typography>
            <Typography variant="body2" sx={{ color: '#856404' }}>
              処理失敗や生成結果がブロックされた場合でも、返金は行われませんのでご了承ください。決済前に利用規約をご確認ください。
            </Typography>
          </Paper>
           {isGenerating && <LinearProgress sx={{ mt: 2 }} />}
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', gap: 1, p: 2 }}>
          {/* モバイル用生成ボタン (下部固定) */}
          <Box sx={{ display: { xs: 'block', md: 'none' }, width: '100%' }}>
            {paymentMethod === 'point' ? (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                fullWidth
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || point < (currentPrice || 0) * 200}
              >
                ポイントで生成 ({((currentPrice || 0) * 200).toLocaleString()}pt)
                {point < (currentPrice || 0) * 200 && ' (残高不足)'}
              </Button>
            ) : paymentMethod === 'coin' ? (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                fullWidth
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || coin < Math.ceil(currentPrice || 0)}
              >
                コインで生成 ({Math.ceil(currentPrice || 0).toLocaleString()}コイン)
                {coin < Math.ceil(currentPrice || 0) && ' (残高不足)'}
              </Button>
            ) : paymentMethod === 'ticket' ? (
              <Button 
                variant="contained" 
                color="success" 
                size="large" 
                fullWidth
                startIcon={<WalletIcon />} 
                onClick={handlePointPayment} 
                disabled={isGenerating || availableTicketCount === 0}
              >
                チケットで生成 (残り{availableTicketCount || 0}回)
                {availableTicketCount === 0 && ticketCount > 0 && ' (条件不一致)'}
                {ticketCount === 0 && ' (チケットなし)'}
              </Button>
            ) : (
              <Button 
                variant="contained" 
                color="primary" 
                size="large" 
                fullWidth
                startIcon={<CreditCardIcon />} 
                onClick={handleStripeCheckout} 
                disabled={isGenerating}
              >
                クレジットカードで生成 ({(currentPrice || 0).toLocaleString()}円)
              </Button>
            )}
          </Box>
          <Button onClick={handleClosePaymentModal} sx={{ display: { xs: 'block', md: 'inline-flex' } }}>キャンセル</Button>
        </DialogActions>
      </Dialog>

      {/* モバイル設定ダイアログ */}
      <Dialog 
        open={settingsDialogOpen} 
        onClose={() => setSettingsDialogOpen(false)}
        fullScreen
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">動画設定</Typography>
            <IconButton onClick={() => setSettingsDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {/* スタイル */}
            {(currentModel !== 'sora-2' && currentModel !== 'sora-2-pro') && (
              <FormControl fullWidth required size="small">
                <InputLabel>スタイル</InputLabel>
                <Select value={settings.style} onChange={(e) => handleSettingChange('style', e.target.value)} label="スタイル">
                  {currentPreset.availableStyles.map((s) => ( <MenuItem key={s.value} value={s.value}>{s.label} {(styleMultipliers[s.value] ?? 1.0) > 1.0 ? ` (+${(( (styleMultipliers[s.value] ?? 1.0) - 1) * 100).toFixed(0)}%)` : ''}</MenuItem> ))}
                </Select>
              </FormControl>
            )}
            {/* 縦横比 (ビジュアルセレクタ) */}
            <Box>
              <Typography variant="caption" display="block" gutterBottom color="text.secondary" sx={{mb: 0.5}}>縦横比</Typography>
              <Grid container spacing={1}>{currentPreset.availableAspectRatios.map((ratio) => { const isSelected = settings.aspectRatio === ratio.value; const aspectVal = ratio.width / ratio.height; let pH = '40px'; let pW = `${40 * aspectVal}px`; if (aspectVal < 1) { pW = '40px'; pH = `${40 / aspectVal}px`; } const maxW = '55px'; const maxH = '55px'; if (parseFloat(pW) > parseFloat(maxW)) { pH = `${parseFloat(pH) * (parseFloat(maxW) / parseFloat(pW))}px`; pW = maxW; } if (parseFloat(pH) > parseFloat(maxH)) { pW = `${parseFloat(pW) * (parseFloat(maxH) / parseFloat(pH))}px`; pH = maxH; } return ( <Grid item key={ratio.value}><Paper onClick={() => handleSettingChange('aspectRatio', ratio.value)} variant="outlined" sx={{ p: 0.5, textAlign: 'center', cursor: 'pointer', borderColor: isSelected ? theme.palette.primary.main : theme.palette.divider, borderWidth: isSelected ? '2px' : '1px', bgcolor: 'transparent', '&:hover': { bgcolor: theme.palette.action.hover, borderColor: theme.palette.primary.light }, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: '70px' }} ><Box sx={{ width: pW, height: pH, bgcolor: isSelected ? theme.palette.primary.lighter : theme.palette.grey[200], border: `1px solid ${isSelected ? theme.palette.primary.light : theme.palette.grey[300]}`, borderRadius: '2px', mb: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }} /><Typography variant="caption" display="block" sx={{lineHeight: 1.1}}>{ratio.label}</Typography><Typography variant="caption" color="text.secondary" sx={{lineHeight: 1.1}}>({ratio.value})</Typography></Paper></Grid> ); })}</Grid>
            </Box>
            {/* 動画の長さ */}
            <FormControl fullWidth required size="small"><InputLabel>動画の長さ</InputLabel><Select value={settings.durationSeconds} onChange={(e) => handleSettingChange('durationSeconds', e.target.value)} label="動画の長さ">{currentPreset.availableVideoLengths.map((l) => ( <MenuItem key={l.value} value={l.value}>{l.label}</MenuItem> ))}</Select></FormControl>
            {/* 音声 (Sora-2/Pro) */}
            {(currentModel === 'sora-2' || currentModel === 'sora-2-pro') && (
              <Box sx={{ p: 1.5, bgcolor: 'info.lighter', borderRadius: 1, border: `1px solid ${theme.palette.info.light}` }}>
                <Typography variant="body2" color="info.main" sx={{ display: 'flex', alignItems: 'center' }}>
                  <InfoIcon fontSize="small" sx={{ mr: 0.5 }} />
                  音声は常に含まれます（自動生成）
                </Typography>
              </Box>
            )}
            {/* 音声オプション (Veo) */}
            {(currentModel !== 'sora-2' && currentModel !== 'sora-2-pro') && (
              <FormControl fullWidth size="small"><InputLabel>音声オプション</InputLabel><Select value={settings.audioType} onChange={(e) => handleSettingChange('audioType', e.target.value)} label="音声オプション">{currentPreset.availableAudioOptions.map((opt) => ( <MenuItem key={opt.value} value={opt.value}> {opt.label} {(audioOptionsPricing[opt.value] ?? 0) > 0 && ` (+${(audioOptionsPricing[opt.value] ?? 0).toLocaleString()}円)`} </MenuItem> ))}</Select></FormControl>
            )}
            {/* 公開設定 */}
            <FormControlLabel control={<Switch checked={settings.publicFlg} onChange={(e) => handleSettingChange('publicFlg', e.target.checked)} color="primary"/>} label={<><Typography variant="body2" component="span">公開設定</Typography><Typography variant="caption" color="text.secondary" display="block">オンにすると他のユーザーも閲覧可能</Typography></>} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSettingsDialogOpen(false)} variant="contained" fullWidth>
            完了
          </Button>
        </DialogActions>
      </Dialog>

      {/* モバイル履歴詳細ダイアログ */}
      <Dialog 
        open={selectedHistoryItem !== null} 
        onClose={() => setSelectedHistoryItem(null)}
        fullScreen
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" noWrap sx={{ maxWidth: '80%' }}>生成詳細</Typography>
            <IconButton onClick={() => setSelectedHistoryItem(null)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedHistoryItem && (
            <Stack spacing={2}>
              {/* プロンプト */}
              <Box>
                <Typography variant="caption" color="text.secondary">プロンプト</Typography>
                <Typography variant="body2">{selectedHistoryItem.prompt || '(No Prompt)'}</Typography>
              </Box>
              
              {/* ステータス */}
              <Box>
                <Typography variant="caption" color="text.secondary">ステータス</Typography>
                <Box sx={{ mt: 0.5 }}>{getStatusChip(selectedHistoryItem.status)}</Box>
              </Box>

              {/* 日時情報 */}
              <Box>
                <Typography variant="caption" color="text.secondary">日時</Typography>
                <Typography variant="body2">作成: {new Date(selectedHistoryItem.create_datetime).toLocaleString()}</Typography>
                {selectedHistoryItem.generate_start_datetime && (
                  <Typography variant="body2">開始: {new Date(selectedHistoryItem.generate_start_datetime).toLocaleString()}</Typography>
                )}
                {selectedHistoryItem.generate_end_datetime && (
                  <Typography variant="body2">完了: {new Date(selectedHistoryItem.generate_end_datetime).toLocaleString()}</Typography>
                )}
              </Box>

              {/* 進捗 */}
              {selectedHistoryItem.progress > 0 && selectedHistoryItem.status === 1 && (
                <LinearProgress variant="determinate" value={selectedHistoryItem.progress} sx={{ height: 6, borderRadius: 1 }} />
              )}

              {/* エラーメッセージ */}
              {selectedHistoryItem.error_message && (
                <Alert severity="error">{selectedHistoryItem.error_message}</Alert>
              )}

              {/* 設定情報 */}
              <Box>
                <Typography variant="caption" color="text.secondary">設定</Typography>
                <Typography variant="body2">スタイル: {selectedHistoryItem.style}</Typography>
                <Typography variant="body2">縦横比: {selectedHistoryItem.aspect_ratio}</Typography>
                <Typography variant="body2">長さ: {selectedHistoryItem.duration_seconds}秒</Typography>
                <Typography variant="body2">バリエーション: {selectedHistoryItem.variation_count}枚</Typography>
                <Typography variant="body2">音声: {selectedHistoryItem.has_audio ? selectedHistoryItem.audio_type || 'あり' : 'なし'}</Typography>
                <Typography variant="body2">公開: {selectedHistoryItem.public_flg ? 'はい' : 'いいえ'}</Typography>
                <Typography variant="body2">料金: {selectedHistoryItem.price?.toLocaleString()}円</Typography>
              </Box>

              {/* プレビュー動画 */}
              {selectedHistoryItem.status === 2 && selectedHistoryItem.file_path && Array.isArray(selectedHistoryItem.file_path) && selectedHistoryItem.file_path.length > 0 && (
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>プレビュー</Typography>
                  <Grid container spacing={1}>
                    {selectedHistoryItem.file_path.map((videoFile, index) => (
                      <Grid item xs={12} key={index}>
                        {videoFile.path ? (
                          <>
                            <video
                              key={`${selectedHistoryItem.proc_id}_${index}`}
                              src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST+`/generated/${videoFile.path}`}
                              controls
                              loop
                              playsInline
                              style={{ width: '100%', maxHeight: '300px', borderRadius: '8px', backgroundColor:'#eee', display: 'block' }}
                              onError={(e) => { console.error(`Video ${index+1} load error:`, e); }}
                            >
                              動画読込失敗 {index + 1}
                            </video>
                            <Typography variant="caption" display="block" align="center" sx={{ mt: 0.5 }} noWrap title={videoFile.path?.split('/').pop()}>
                              {videoFile.path?.split('/').pop() || `動画 ${index + 1}`}
                            </Typography>
                          </>
                        ) : (
                          <Paper sx={{ height: '100px', display:'flex', alignItems:'center', justifyContent:'center', bgcolor:'grey.200' }}>
                            <Typography variant="caption" color="text.secondary">パス無効 {index + 1}</Typography>
                          </Paper>
                        )}
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}

              {/* ダウンロードボタン */}
              {selectedHistoryItem.status === 2 && selectedHistoryItem.file_path && Array.isArray(selectedHistoryItem.file_path) && selectedHistoryItem.file_path.length > 0 && (
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>ダウンロード</Typography>
                  <Stack spacing={1}>
                    {selectedHistoryItem.file_path.map((videoFile, index) => (
                      videoFile.path ? (
                        <Button
                          key={`download-${index}`}
                          variant="contained"
                          size="medium"
                          fullWidth
                          href={ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST+`/generated/${videoFile.path}`}
                          download={videoFile.path.split('/').pop() || `video_${selectedHistoryItem.proc_id}_${index+1}.mp4`}
                          startIcon={<DownloadIcon />}
                        >
                          動画 {index + 1} をダウンロード
                        </Button>
                      ) : null
                    ))}
                  </Stack>
                </Box>
              )}
            </Stack>
          )}
        </DialogContent>
      </Dialog>

      {/* Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%', boxShadow: 6 }} variant="filled">{snackbarMessage}</Alert>
      </Snackbar>
    </Box>
  );
};

export default AIVideoGenerator; // コンポーネントをエクスポート